var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDriveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 21,
    viewBox: "0 0 24 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_6812)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.81444 17.977L2.87287 19.7652C3.09281 20.1417 3.40894 20.4375 3.78009 20.6527C4.84316 19.3327 5.58316 18.3198 6.00009 17.6139C6.42322 16.8976 6.94325 15.7771 7.56019 14.2525C5.89744 14.0384 4.63744 13.9314 3.78019 13.9314C2.95737 13.9314 1.69731 14.0384 0 14.2525C0 14.6693 0.109969 15.0861 0.329906 15.4627L1.81444 17.977Z",
    fill: "#0066DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2199 20.6527C20.5912 20.4375 20.9073 20.1417 21.1271 19.7653L21.567 19.0258L23.6702 15.4627C23.8861 15.0943 23.9998 14.6771 24 14.2525C22.2928 14.0384 21.0351 13.9314 20.2269 13.9314C19.3582 13.9314 18.1004 14.0384 16.4536 14.2525C17.0632 15.7855 17.5764 16.906 17.9932 17.6139C18.4134 18.3282 19.1557 19.3411 20.2199 20.6527Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 6.72284C13.2303 5.26978 14.078 4.14932 14.5433 3.36147C14.918 2.72707 15.3304 1.71414 15.7804 0.322703C15.4092 0.107568 14.9832 0 14.5433 0H9.45734C9.01746 0 8.59146 0.121048 8.22021 0.322703C8.79271 1.91852 9.27846 3.05423 9.67746 3.72984C10.1185 4.47648 10.8927 5.47415 12.0003 6.72284Z",
    fill: "#00832D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.4401 14.2524H7.56027L3.78027 20.6526C4.15134 20.8677 4.57743 20.9753 5.0173 20.9753H18.9831C19.4229 20.9753 19.8491 20.8542 20.2202 20.6525L16.4401 14.2524Z",
    fill: "#2684FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 6.7228L8.22009 0.322754C7.84884 0.537889 7.53272 0.833632 7.31278 1.21016L0.329906 13.0423C0.114024 13.4107 0.000298266 13.8278 0 14.2524H7.56019L12.0001 6.7228Z",
    fill: "#00AC47"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.1788 7.1263L16.6872 1.21016C16.4674 0.833632 16.1512 0.537889 15.78 0.322754L12 6.72289L16.4398 14.2525H23.9863C23.9863 13.8357 23.8763 13.419 23.6564 13.0424L20.1788 7.1263Z",
    fill: "#FFBA00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_6812"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDriveIcon);
export default __webpack_public_path__ + "static/media/drive-icon.ab22089885bee25e9ff36ddd21a8fc86.svg";
export { ForwardRef as ReactComponent };